import React, { useState, useEffect } from "react";

import { Alert } from "services/Alert";
import { Schema, SelectPicker, Table } from "rsuite";
import { connect } from "react-redux";
import styled from "styled-components";

import { api } from "api/loginRoutes"
import { ButtonPrimary } from "components/base/BaseButton";
import CustomField from "components/Form/CustomField";
import BaseTable from "components/base/BaseTable";
import RateField from "components/Form/RateField";
import { Icon } from "components/Icon";
import {
    API_Modal,
    MyForm,
    NumbersSelect,
    SDE_Component,
    NumberField,
    CheckboxControl,
    ErrorMessage
} from "components";

const { NumberType } = Schema.Types;

const generateRangesModel = {
    ranges: NumberType()
        .isRequired("Required")
        .isInteger("Only whole numbers")
};

const AddNewSubdestination = ({ p_key, cur_key, currency_list, update, price_list, defaultSPKey, paymentTermsList }) => {
    const [show, setShow] = useState(false);
    const [disabledRanges, setDisabled] = useState(true);
    const [rates, setRates] = useState([]);
    const [touched, setTouched] = useState(false);
    const [sdeList, setSdeList] = useState([]);
    const [sde_key, setSdeKey] = useState(null);

    const [isEntered, setIsEntered] = useState(false);

    const getNewsubdestinationList = (pKey, curKey) => {
        api("newsubdestination_list_for_price", { p_key: pKey, cur_key: curKey })
            .then(({ subdestination_list: data }) => setSdeList(data || []));
    };

    useEffect(() => {
        if (show) {
            setTouched(false);
            setRates([]);
            setSdeKey(null);
            setSdeList([]);
            getNewsubdestinationList(p_key, cur_key);
        }
    }, [show]);

    const onChangeRate = (cur_key, pt_key, rate) => {
        if (!touched) setTouched(true);

        setRates(rates => {
            const _rates = rates.filter(
                rateObj => rateObj.cur_key !== cur_key || rateObj.pt_key !== pt_key
            );

            if (rate)
                return [..._rates, { cur_key, pt_key, rate }];

            return _rates;
        });
    };

    const field1 = <NumberField
        disabled={disabledRanges}
        min={1}
        step={1}
        label="Ranges"
        name="ranges"
    />;

    const field2 = <NumbersSelect
        disabled={disabledRanges}
        label="Numbers"
        name="numbers"
    />;

    const noGenerateRange = disabledRanges || !sde_key;

    const unsendFields = [];
    for (const currency of currency_list) {
        for (const term of paymentTermsList) {
            unsendFields.push(`${currency.cur_key}-${term.pt_key}`);
        }
    }

    return (
        <>
            <ButtonPrimary
                onClick={() => setShow(true)}
            >
                <Icon icon="plus" /> Add subdestination
            </ButtonPrimary>

            {show &&
                <API_Modal
                    title="Add new Subdestination"
                    onClose={() => {
                        setDisabled(true);
                        setShow(false);
                        setIsEntered(false);
                    }}
                    successText="Create"
                    update={update}
                    checkFirstAll
                    checkBefore={() => {
                        if (!touched) setTouched(true);

                        return !!rates.length;
                    }}
                    onEntered={() => setIsEntered(true)}
                >
                    <MyForm
                        method="service_plan_price:new_subdestination"
                        formDefaultValue={{ p_key }}
                        addData={{
                            rates: rates
                        }}
                        noCheck
                        deepCloned={false}
                        //remove rates fields from request
                        unsendFields={unsendFields}
                    >

                        <CustomField
                            accepter={SelectPicker}
                            labelKey="name"
                            valueKey="p_key"
                            name="p_key"
                            data={price_list}
                            placeholder="Prices"
                            searchable={false}
                            cleanable={false}
                            classPrefix="allocated"
                            onChange={(pKey) => {
                                getNewsubdestinationList(pKey, cur_key)
                            }}
                        />
                        <SDE_Component
                            subdestination_list={sdeList}
                            labelKey="subdestination_name"
                            name="sde_key"
                            validationKey="num_required"
                            onChange={(v) => setSdeKey(v)}
                        />
                        {touched && !rates.length &&
                            <ErrorMessage>
                                Must be filled at least one Currency.
                            </ErrorMessage>}
                        <TablePayments
                            data={currency_list}
                            onChange={onChangeRate}
                            paymentTermsList={paymentTermsList}
                            loading={!isEntered}
                        />
                    </MyForm>
                    <MyForm
                        formDefaultValue={{ sp_key: defaultSPKey, numbers: 1000, ranges: 1 }}
                        method="price_range__generate_by_sde"
                        checkResultKey="ranges"
                        update={({ ranges }) => {
                            Alert.success(`Generated ${ranges || 0} ranges`)
                        }}
                        addData={{
                            sde_key
                        }}
                        noSend={noGenerateRange}
                        deepCloned={false}
                        model={generateRangesModel}
                    >
                        <CheckboxControl
                            onChange={(value) => setDisabled(!value)}
                            useBr>
                            Make Ranges
                        </CheckboxControl>

                        {disabledRanges ? <Fieldset>{field1} {field2}</Fieldset> : <></>}
                        {!disabledRanges ? field1 : <></>}
                        {!disabledRanges ? field2 : <></>}
                    </MyForm>
                </API_Modal>
            }
        </>
    );
};

const mapStateToProps = ({ references }) => ({
    defaultSPKey: references.defaultSPKey
});

export default connect(mapStateToProps)(AddNewSubdestination);

const { Column, HeaderCell, Cell } = Table;

const TablePayments = ({ data, disabled, onChange, paymentTermsList = [] }) => (
    <BaseTable
        height={140}
        data={data}
        rowHeight={50}
    >
        <Column width={100}>
            <HeaderCell>Currency</HeaderCell>
            <Cell dataKey="name" />
        </Column>

        {paymentTermsList.map(term => (
            <Column flexGrow={1}>
                <HeaderCell>{term.name.replace("_", "-")}</HeaderCell>
                <Cell>
                    {(row, i) => (
                        <RateField
                            width={paymentTermsList.length > 2 ? 110 : 135}
                            disabled={disabled}
                            onChange={v => onChange(row.cur_key, term.pt_key, +v)}
                            name={`${row.cur_key}-${term.pt_key}`}
                        />
                    )}

                </Cell>
            </Column>
        ))}
        <Column key="table_scrollfix" width={0} fixed>
            <HeaderCell></HeaderCell>
            <Cell></Cell>
        </Column>
    </BaseTable>
);

const Fieldset = styled.fieldset`
    border: none;
    margin: 0;
    padding: 0;
    > div {
        margin-right: 10px;
        vertical-align: middle;
    }
`;
